import vueQr from './components/index.js'

const qrComponent = {vueQr};

// 定义 install 方法，接收 Vue 作为参数。如果使用 use 注册插件，那么所有的组件都会被注册
const install = function (Vue) {
  // 判断是否安装
  if (install.installed) return
  // 遍历注册全局组件
  for (var name in qrComponent) Vue.component(name, qrComponent[name]);
}
// 判断是否是直接引入文件
if (typeof window !== 'undefined') {
  if (window.Vue)
    install(window.Vue)
  else //供外部调用
      window.qrVueComponent = qrComponent;
}
// 导出的对象必须具有 install，才能被 Vue.use() 方法安装
export default Object.assign({ install }, qrComponent);
